import { createStore, createHook, defaults } from 'react-sweet-state';
import _ from 'lodash';

// Integrate react-sweet-state with the redux dev tools.
defaults.devtools = true;

/**
 * @param {INFO | ERROR | WARNING | SUCCESS} type
 * @param {string} text
 * @param {boolean} createOnNavigate
 */
export const createToastConfig = (type, text, createOnNavigate = false) => {
    return { type, text, createOnNavigate };
};

const emptyToast = { type: null, text: null, createOnNavigate: false };

const Store = createStore({
    name: 'Toasts',

    initialState: emptyToast,

    actions: {
        createToast:
            (toast) =>
            ({ setState }) =>
                setState({ ...toast, id: _.uniqueId() }),
        queueDelayedToast:
            () =>
            ({ setState, getState }) => {
                if (getState() && getState().createOnNavigate) {
                    setState({ ...getState(), createOnNavigate: false });
                }
            },
    },
});

export const INFO = 'Info';
export const ERROR = 'Error';
export const WARNING = 'Warning';
export const SUCCESS = 'Success';

const useToasts = createHook(Store);
export default useToasts;
